import {
    ErrorResponse,
    GetReserveShiftsReportRequest,
    ShiftReportsList,
} from "../../api";
import { commonSlice, store } from "../../store";

import { reserveShiftsSlice } from "../../features/Reserve/store";
import { api } from "../common/make_api";

import { ShiftsRequest } from "../../api/models/ShiftsRequest";
import { convertRequestMonth } from "../common/convert";
import {
    ActionType,
    ResourceType,
    sendLog,
    StatusType,
} from "../common/send_log";
import { Logout } from "../login/login";

export async function selectShiftsReport(): Promise<any> {
    store.dispatch(commonSlice.actions.startLoading());

    try {
        store.dispatch(reserveShiftsSlice.actions.update_shift_reports(null));

        const state = store.getState();
        const selectedOfficeId = state.reserveShifts.officeId ?? -1;
        const officeIds = state.common.officeIds;

        const guidanceOnly = state.reserveShifts.needGuidanceOnly;
        const shiftsRequest: ShiftsRequest = {
            officeId: selectedOfficeId,
        };

        // multi-office user
        if (selectedOfficeId == -1) {
            if (officeIds) {
                shiftsRequest["officeIds"] = officeIds;
            }
        }

        if (state.reserveShifts.startDate) {
            const shitstart = convertRequestMonth(
                state.reserveShifts.startDate
            );
            shiftsRequest["shiftStartDate"] = shitstart;
        }

        if (state.reserveShifts.endDate) {
            const shiftend = convertRequestMonth(state.reserveShifts.endDate);
            shiftsRequest["shiftEndDate"] = shiftend;
        }

        if (
            state.reserveShifts.driverIds &&
            typeof state.reserveShifts.driverIds[0] == typeof 2
        ) {
            shiftsRequest["driverIds"] = state.reserveShifts.driverIds;
        }

        const req: GetReserveShiftsReportRequest = {
            reserveShiftsRequest: shiftsRequest,
        };

        const res = await api.getReserveApi().getReserveShiftsReport(req);

        sendLog(
            ResourceType.SHIFTS_MONITORING,
            StatusType.GET_RESOURCE,
            ActionType.SELECT_SHIFTS_REPORTS
        );

        if (guidanceOnly) {
            const _res = filterByGuidance(res);
            const _r = _res ? _res : null;
            store.dispatch(reserveShiftsSlice.actions.update_shift_reports(_r));
            return _res;
        }
        store.dispatch(reserveShiftsSlice.actions.update_shift_reports(res));
        return res;
        //
    } catch (err) {
        console.log("Got this error from shift_reports:", err);
        if (err["status"] == 401) {
            console.log("Session has expired");
            Logout();
            return;
        }

        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return null;
        }
        if (err.status && err.status == 500) {
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return null;
        }
        const res = (await (err as Response).json()) as ErrorResponse;
        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
}

const filterByGuidance = (res: ShiftReportsList) => {
    const _s = res.shiftReports;
    if (!_s) {
        return null;
    }

    const _f = _s.filter((x) => {
        return (
            x.needGuidanceBreaks == "required" ||
            x.needGuidanceEarnings == "required" ||
            x.needGuidanceHermes == "required"
        );
    });

    return { shiftReports: _f } as ShiftReportsList;
};
